import React from "react";
import { ScrollView, Text, View } from "react-native";

import steps from "../steps";
import { hasItems, isNativeApp, navigate } from "../../../../../helpers/utils";
import IntegrationsHelper from "../../IntegrationsHelper";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import CalendarItem from "../../home/calendar/CalendarItem";
import styles from "../integrationStyles";
import ManaButton from "../../../common/ManaButton";

export default function CalendarIntegrationSelection({
  controller,
  account,
  calendars = [],
  calendarType = "google_calendar",
  goToStep = () => {},
  isFromCard = false,
  onContinue,
}) {
  const buttonText = isFromCard ? "Finish" : "Continue";

  const saveSelection = () => {
    const selection = {};
    calendars.forEach((c) => {
      selection[c.id + " " + c.name] = c.isSelected;
    });

    const action = {
      type:  "calendar_google",
      account: account.email,
      calendars: selection
    };
    IntegrationsHelper.saveIntegrationSource(controller, action);
  };

  const updateCalendarSettings = (cal, isSelected) => {
    cal.isSelected = isSelected;
    saveSelection();
  }

  const onButtonPress = () => {
    saveSelection();

    if (onContinue) return onContinue();

    if (isFromCard) {
      navigate(controller, appPages.integrationsV2);
    } else {
      goToStep(isNativeApp() ? steps.checklist : steps.desktop);
    }
  };

  return (
    <>
      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.header}>Which calendars should we connect?</Text>

        {calendars.map((cal, index) => (
          <CalendarItem
            item={cal}
            key={index}
            onToggle={updateCalendarSettings}
          />
        ))}
      </ScrollView>

      <View style={[appStyles.footerButtons]}>
        <ManaButton
          isMainButton
          text={buttonText}
          onPress={onButtonPress}
          style={appStyles.bottomButton}
          textStyle={appStyles.bottomButtonText}
        />
      </View>
    </>
  );
}
